import SmoothScroll from "smooth-scroll";

var scroll = new SmoothScroll('a[href*="#"]', {
    speed: 500,
    speedAsDuration: true,
});

// 流入元の判定
let source_param = "not_found";
const url = new URL(location.href);
const params = url.searchParams;

if (params.get("source")) source_param = params.get("source");

// スクロールできますを表示する処理
function scrollBanner() {
    const tableScroll = document.querySelector(".table-scroll");
    const scrollable = document.querySelector(".scrollable");
    const option = {
        root: document.querySelector("#observerArea"),
        rootMargin: "0px",
        threshold: 0.5,
    };
    const observer = new IntersectionObserver((entries, observer) => {
        if (window.innerWidth < 840) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    scrollable.classList.add("active");

                    window.setTimeout(() => {
                        scrollable.classList.remove("active");
                    }, 900);

                    observer.unobserve(entry.target);
                }
            });
        }
    }, option);

    observer.observe(tableScroll);
}

// アコーディオンの処理
function accordion() {
    const cards = document.querySelectorAll(".faq__card");
    const answers = document.querySelectorAll(".faq__card__answer");

    cards.forEach((elm, index) => {
        elm.addEventListener("click", () => {
            elm.classList.toggle("active");

            if (elm.classList.contains("active")) {
                const height = answers[index].scrollHeight;

                answers[index].style.height = `${height}px`;
            } else {
                answers[index].style.height = 0;
            }
        });
    });
}

// Slackにメッセージを送るPHPファイルにPOSTする
function sendSlack(
    user_name,
    company_name,
    tel_number_01,
    tel_number_02,
    tel_number_03,
    user_mail
) {
    const url = "./app/slack.php";

    $.ajax(url, {
        type: "post",
        data: {
            user_name: user_name,
            company_name: company_name,
            tel_number_01: tel_number_01,
            tel_number_02: tel_number_02,
            tel_number_03: tel_number_03,
            user_mail: user_mail,
            source: source_param,
        },
        dataType: "text",
    });
}

// GASを動かすためのPHPファイルにPOSTする
function sendGas(
    user_name,
    company_name,
    tel_number_01,
    tel_number_02,
    tel_number_03,
    user_mail
) {
    const url = "./app/gas.php";

    $.ajax(url, {
        type: "post",
        data: {
            user_name: user_name,
            company_name: company_name,
            tel_number_01: tel_number_01,
            tel_number_02: tel_number_02,
            tel_number_03: tel_number_03,
            user_mail: user_mail,
            source: source_param,
        },
        dataType: "json",
    }).done((data) => {
        console.log(data.parameter);
    });
}

// メールを送るためのPHPファイルにPOSTする
function sendmail(
    user_name,
    company_name,
    tel_number_01,
    tel_number_02,
    tel_number_03,
    user_mail
) {
    const url = "./app/sendmail.php";

    $.ajax(url, {
        type: "post",
        data: {
            user_name: user_name,
            company_name: company_name,
            tel_number_01: tel_number_01,
            tel_number_02: tel_number_02,
            tel_number_03: tel_number_03,
            user_mail: user_mail,
            source: source_param,
        },
        dataType: "text",
    })
        .done((data) => {
            sendSlack(
                user_name,
                company_name,
                tel_number_01,
                tel_number_02,
                tel_number_03,
                user_mail
            );
            sendGas(
                user_name,
                company_name,
                tel_number_01,
                tel_number_02,
                tel_number_03,
                user_mail
            );
            window.location.href = "./thanks/";
        })
        .fail((data) => {
            alert(
                "送信に失敗しました。時間をおいて再度送信をお願いいたします。"
            );
            console.log(data);
        });
}

function stepForm() {
    const formTop = document.getElementById("form-top");
    const formButton = document.querySelectorAll(".form-top button");
    const back = document.querySelectorAll(".form-top a.back");
    const progress = document.querySelectorAll(
        ".step-form__wrapper .progress p"
    );
    const user_name = document.getElementById("user-name");
    const company_name = document.getElementById("company-name");
    const tel_number_01 = document.getElementById("tel-number-01");
    const tel_number_02 = document.getElementById("tel-number-02");
    const tel_number_03 = document.getElementById("tel-number-03");
    const user_mail = document.getElementById("user-mail");

    formButton.forEach((elm, index) => {
        elm.addEventListener("click", (e) => {
            if (index == 0 && user_name.value != "") {
                formTop.style.justifyContent = "center";
                progress.forEach((e) => {
                    e.removeAttribute("class");
                });
                progress[1].setAttribute("class", "active");
                progress.forEach((e, i) => {
                    e.innerText = `STEP ${i + 1}`;
                });
                e.preventDefault();
            } else if (
                index == 1 &&
                tel_number_01.value != "" &&
                tel_number_02.value != "" &&
                tel_number_03.value != ""
            ) {
                formTop.style.justifyContent = "flex-end";
                progress.forEach((e) => {
                    e.removeAttribute("class");
                });
                progress[2].setAttribute("class", "active");
                progress.forEach((e, i) => {
                    e.innerText = `STEP ${i + 1}`;
                });
                e.preventDefault();
            } else if (index == 2 && user_mail.value != "") {
                sendmail(
                    user_name.value,
                    company_name.value,
                    tel_number_01.value,
                    tel_number_02.value,
                    tel_number_03.value,
                    user_mail.value
                );

                elm.setAttribute("disabled", "");
                e.preventDefault();
            }
        });
    });

    back.forEach((elm, index) => {
        elm.addEventListener("click", () => {
            if (index == 0) {
                formTop.style.justifyContent = "flex-start";
                progress.forEach((e) => {
                    e.classList.remove("active");
                });
                progress[index].classList.add("active");
                progress.forEach((e, i) => {
                    e.innerText = `STEP ${i + 1}`;
                });
            } else if (index == 1) {
                formTop.style.justifyContent = "center";
                progress.forEach((e) => {
                    e.classList.remove("active");
                });
                progress[index].classList.add("active");
                progress.forEach((e, i) => {
                    e.innerText = `STEP ${i + 1}`;
                });
            }
        });
    });
}

function normalForm() {
    const mainForm = document.getElementById("main-form");
    const sendButton = document.querySelector("#main-form button");
    const user_name = document.getElementById("main-user-name");
    const company_name = document.getElementById("main-company-name");
    const tel_number_01 = document.getElementById("main-tel-number-01");
    const tel_number_02 = document.getElementById("main-tel-number-02");
    const tel_number_03 = document.getElementById("main-tel-number-03");
    const user_mail = document.getElementById("main-user-mail");

    mainForm.addEventListener("submit", (e) => {
        sendmail(
            user_name.value,
            company_name.value,
            tel_number_01.value,
            tel_number_02.value,
            tel_number_03.value,
            user_mail.value
        );

        sendButton.setAttribute("disabled", "");
        e.preventDefault();
    });
}

window.addEventListener("load", () => {
    stepForm();
    accordion();
    normalForm();
    scrollBanner();
});
